import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
@charset "UTF-8";
.dashboard-page {
  box-sizing: border-box;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 30px 38px 42px;
  color: #172033;
  background: radial-gradient(circle at 8% 0%, rgba(124, 58, 237, 0.08), transparent 28%), linear-gradient(180deg, #fbfaff 0%, #f7f6fa 100%);
}

.dashboard-page *,
.dashboard-page *::before,
.dashboard-page *::after {
  box-sizing: inherit;
}

button {
  font: inherit;
}

.dashboard-header,
.dashboard-content {
  width: 100%;
  max-width: 1180px;
  margin-right: auto;
  margin-left: auto;
}

.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  margin-bottom: 24px;
}

.today-label {
  margin: 0 0 7px;
  color: #7c3aed;
  font-size: 11px;
  font-weight: 900;
}

.header-copy h1 {
  margin: 0;
  color: #111827;
  font-size: clamp(25px, 2.2vw, 31px);
  font-weight: 900;
  letter-spacing: -0.04em;
}

.header-copy > p:last-child {
  margin: 8px 0 0;
  color: #6b7280;
  font-size: 13px;
}

.respond-button,
.detail-button,
.inline-link,
.section-link,
.summary-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
}

.dashboard-content {
  display: grid;
  gap: 15px;
}

.section-card {
  min-width: 0;
  padding: 20px 22px;
  border: 1px solid rgba(228, 222, 238, 0.78);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 12px 34px rgba(61, 43, 88, 0.055);
}

.section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 14px;
}

.section-head > div {
  position: relative;
  min-width: 0;
}

.section-head h2 {
  margin: 0;
  color: #172033;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: -0.025em;
}

.section-head p {
  margin: 6px 0 0;
  color: #8a94a6;
  font-size: 11px;
}

.count-badge,
.week-range {
  flex: 0 0 auto;
  padding: 6px 9px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  background: #f5f3ff;
}

.week-range {
  color: #64748b;
  background: #f8fafc;
}

.week-navigator {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex: 0 0 auto;
}

.week-nav-button {
  display: grid;
  place-items: center;
  width: 27px;
  height: 27px;
  flex: 0 0 27px;
  padding: 0;
  border: 1px solid #ebe6f3;
  border-radius: 9px;
  color: #7c3aed;
  cursor: pointer;
  background: #fff;
  transition: border-color 150ms ease, background 150ms ease, transform 150ms ease;
}

.week-nav-button:hover:not(:disabled) {
  border-color: #c4b5fd;
  background: #f8f5ff;
  transform: translateY(-1px);
}

.week-nav-button:disabled {
  color: #c4b5d8;
  cursor: wait;
  background: #f8fafc;
}

.week-nav-button svg {
  width: 13px;
  height: 13px;
}

.request-list {
  display: grid;
  gap: 9px;
}

.request-row {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) minmax(140px, auto) auto;
  align-items: center;
  gap: 12px;
  padding: 9px 11px;
  border: 1px solid #eeeaf4;
  border-radius: 14px;
  background: #fff;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.request-row:hover {
  border-color: #ddd3ef;
  box-shadow: 0 8px 22px rgba(73, 49, 112, 0.07);
}

.request-icon {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  color: #7c3aed;
  background: #f3efff;
}

.request-icon.place {
  color: #db2777;
  background: #fdf2f8;
}

.request-icon svg {
  width: 19px;
  height: 19px;
}

.request-copy {
  min-width: 0;
}

.request-labels {
  display: flex;
  align-items: center;
  gap: 6px;
}

.request-labels span,
.request-labels em {
  overflow: hidden;
  color: #64748b;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-labels span {
  max-width: 170px;
}

.request-labels em {
  flex: 0 0 auto;
  padding: 2px 6px;
  border-radius: 999px;
  color: #6d28d9;
  background: #f5f3ff;
}

.request-copy h3 {
  margin: 5px 0 0;
  overflow: hidden;
  color: #263145;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-deadline {
  min-width: 0;
}

.request-deadline > span,
.request-deadline small {
  display: block;
}

.request-deadline > span {
  color: #64748b;
  font-size: 10px;
  font-weight: 900;
}

.request-deadline > span.warning {
  color: #d97706;
}

.request-deadline > span.danger {
  color: #e11d48;
}

.request-deadline small {
  max-width: 175px;
  margin-top: 3px;
  overflow: hidden;
  color: #9aa4b3;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.respond-button {
  gap: 5px;
  min-height: 35px;
  padding: 0 12px;
  border-radius: 10px;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  background: #7c3aed;
  transition: background 160ms ease, transform 160ms ease;
}

.respond-button:hover {
  background: #6d28d9;
  transform: translateX(2px);
}

.respond-button svg {
  width: 13px;
  height: 13px;
}

.quiet-state {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  padding: 10px 13px;
  border: 1px dashed #dce7e2;
  border-radius: 14px;
  background: #fbfefc;
}

.quiet-icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border-radius: 10px;
  color: #059669;
  background: #ecfdf5;
}

.quiet-icon svg {
  width: 18px;
  height: 18px;
}

.quiet-state > div {
  min-width: 0;
  flex: 1 1 auto;
}

.quiet-state strong {
  display: block;
  color: #334155;
  font-size: 12px;
  font-weight: 900;
}

.quiet-state p {
  margin: 4px 0 0;
  color: #94a3b8;
  font-size: 10px;
}

.inline-link {
  flex: 0 0 auto;
  padding: 6px 8px;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  background: transparent;
}

.section-link {
  gap: 2px;
  flex: 0 0 auto;
  padding: 5px 0;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 900;
  background: transparent;
}

.section-link svg {
  width: 13px;
  height: 13px;
}

.next-feature {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto;
  align-items: stretch;
  gap: 18px;
  min-height: 148px;
  padding: 16px;
  border: 1px solid #e8e0fa;
  border-radius: 17px;
  background: radial-gradient(circle at 98% 10%, rgba(167, 139, 250, 0.18), transparent 30%), linear-gradient(135deg, #faf8ff, #fff);
}

.feature-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  color: #fff;
  background: linear-gradient(145deg, #7c3aed, #8b5cf6);
  box-shadow: 0 12px 25px rgba(124, 58, 237, 0.19);
}

.feature-date span {
  font-size: 11px;
  font-weight: 800;
}

.feature-date strong {
  margin: 4px 0 2px;
  font-size: 38px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.05em;
}

.feature-date small {
  color: #ddd6fe;
  font-size: 9px;
  font-weight: 800;
}

.feature-copy {
  align-self: center;
  min-width: 0;
}

.feature-kicker {
  display: flex;
  align-items: center;
  gap: 7px;
}

.feature-kicker span {
  overflow: hidden;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feature-kicker em {
  flex: 0 0 auto;
  padding: 3px 7px;
  border-radius: 999px;
  color: #e11d48;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  background: #fff1f2;
}

.feature-copy h3 {
  margin: 7px 0 11px;
  overflow: hidden;
  color: #172033;
  font-size: 21px;
  font-weight: 900;
  letter-spacing: -0.03em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feature-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 15px;
}

.feature-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  color: #64748b;
  font-size: 10px;
}

.feature-meta svg {
  width: 13px;
  height: 13px;
  flex: 0 0 auto;
  color: #8b5cf6;
}

.feature-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  min-width: 125px;
  padding: 7px 3px 5px;
}

.attendee-info {
  display: flex;
  align-items: center;
  gap: 7px;
}

.attendee-info > strong {
  color: #64748b;
  font-size: 9px;
  white-space: nowrap;
}

.avatar-stack {
  display: flex;
  padding-left: 5px;
}

.avatar-stack > span {
  display: grid;
  overflow: hidden;
  place-items: center;
  width: 24px;
  height: 24px;
  margin-left: -5px;
  border: 2px solid #fff;
  border-radius: 999px;
  color: #fff;
  font-size: 8px;
  font-weight: 900;
  background: #7c3aed;
}

.avatar-stack > span > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-stack > span:nth-child(2) {
  background: #10b981;
}

.avatar-stack > span:nth-child(3) {
  background: #f97316;
}

.detail-button {
  min-height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  background: #172033;
  transition: background 160ms ease, transform 160ms ease;
}

.detail-button:hover {
  background: #7c3aed;
  transform: translateY(-1px);
}

.later-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.later-row {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto 14px;
  align-items: center;
  gap: 11px;
  min-width: 0;
  padding: 9px 11px;
  border: 1px solid #edf0f4;
  border-radius: 13px;
  color: inherit;
  text-align: left;
  cursor: pointer;
  background: #fff;
  transition: border-color 160ms ease, background 160ms ease;
}

.later-row:hover {
  border-color: #ddd6fe;
  background: #fcfbff;
}

.later-date {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  color: #6d28d9;
  background: #f5f3ff;
}

.later-date strong {
  font-size: 15px;
  font-weight: 900;
  line-height: 1;
}

.later-date small {
  margin-top: 2px;
  font-size: 8px;
  font-weight: 800;
}

.later-copy {
  min-width: 0;
}

.later-copy em,
.later-copy strong,
.later-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.later-copy em {
  color: #8b5cf6;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
}

.later-copy strong {
  margin-top: 3px;
  color: #334155;
  font-size: 11px;
  font-weight: 900;
}

.later-copy small {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 8px;
}

.later-dday {
  color: #e11d48;
  font-size: 9px;
  font-weight: 900;
  white-space: nowrap;
}

.later-row > svg {
  width: 14px;
  height: 14px;
  color: #c4b5d8;
}

.next-empty {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 78px;
  padding: 11px 13px;
  border: 1px dashed #ddd6e8;
  border-radius: 16px;
  background: #fcfbfd;
}

.empty-date {
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  flex: 0 0 52px;
  border-radius: 12px;
  color: #8b5cf6;
  background: #f5f3ff;
}

.empty-date span {
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
}

.empty-date strong {
  font-size: 9px;
}

.next-empty > div:nth-child(2) {
  min-width: 0;
  flex: 1 1 auto;
}

.next-empty h3 {
  margin: 0;
  color: #334155;
  font-size: 13px;
  font-weight: 900;
}

.next-empty p {
  margin: 5px 0 0;
  color: #94a3b8;
  font-size: 10px;
}

.week-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
}

.week-day {
  min-width: 0;
  min-height: 108px;
  padding: 8px 7px;
  border: 1px solid #edf0f4;
  border-radius: 13px;
  background: #fbfcfd;
}

.week-day.has-events {
  border-color: #ddd6fe;
  background: #fdfcff;
}

.week-day.today {
  border-color: #8b5cf6;
  box-shadow: inset 0 0 0 1px rgba(139, 92, 246, 0.12);
}

.day-head {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 2px 6px;
  border-bottom: 1px solid #edf0f4;
}

.day-head > span {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 800;
}

.day-head strong {
  color: #475569;
  font-size: 14px;
  font-weight: 900;
}

.today .day-head strong {
  display: grid;
  place-items: center;
  width: 25px;
  height: 25px;
  border-radius: 999px;
  color: #fff;
  background: #7c3aed;
}

.day-head small {
  margin-left: auto;
  color: #7c3aed;
  font-size: 7px;
  font-weight: 900;
}

.day-events {
  display: grid;
  gap: 5px;
  padding-top: 6px;
}

.week-event {
  display: block;
  width: 100%;
  min-width: 0;
  padding: 5px 6px;
  border: 0;
  border-radius: 9px;
  color: #4c1d95;
  text-align: left;
  cursor: pointer;
  background: #ede9fe;
  transition: background 150ms ease, transform 150ms ease;
}

.week-event:hover {
  background: #ddd6fe;
  transform: translateY(-1px);
}

.week-event time,
.week-event strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.week-event time {
  color: #8b5cf6;
  font-size: 7px;
  font-weight: 900;
}

.week-event strong {
  margin-top: 2px;
  font-size: 9px;
  font-weight: 900;
}

.no-event,
.more-events {
  display: block;
  color: #c1c8d2;
  font-size: 8px;
  text-align: center;
}

.no-event {
  padding-top: 11px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 15px;
}

.summary-card {
  padding: 18px 20px;
}

.summary-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.summary-head h2 {
  margin: 0;
  color: #172033;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: -0.025em;
}

.summary-head p {
  margin: 4px 0 0;
  color: #94a3b8;
  font-size: 9px;
}

.summary-link {
  gap: 2px;
  flex: 0 0 auto;
  padding: 3px 0;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  background: transparent;
}

.summary-link svg {
  width: 12px;
  height: 12px;
}

.meeting-summary-list,
.poll-summary-list {
  display: grid;
}

.meeting-summary-row,
.poll-summary-row {
  width: 100%;
  min-width: 0;
  border: 0;
  color: inherit;
  text-align: left;
  cursor: pointer;
  background: transparent;
  transition: background 150ms ease;
}

.meeting-summary-row {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto 13px;
  align-items: center;
  gap: 9px;
  padding: 8px 6px;
  border-top: 1px solid #f0edf4;
}

.meeting-summary-row:first-child,
.poll-summary-row:first-child {
  border-top: 0;
}

.meeting-summary-row:hover,
.poll-summary-row:hover {
  background: #faf8ff;
}

.meeting-avatar {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  color: #6d28d9;
  font-size: 11px;
  font-weight: 900;
  background: #f3efff;
}

.meeting-summary-copy {
  min-width: 0;
}

.meeting-summary-copy strong,
.meeting-summary-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meeting-summary-copy strong {
  color: #334155;
  font-size: 11px;
  font-weight: 900;
}

.meeting-summary-copy small {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 8px;
}

.role-badge {
  padding: 3px 6px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 7px;
  font-weight: 900;
  background: #f5f3ff;
}

.meeting-summary-row > svg {
  width: 13px;
  height: 13px;
  color: #c4b5d8;
}

.poll-summary-row {
  display: block;
  padding: 9px 6px 10px;
  border-top: 1px solid #f0edf4;
}

.poll-summary-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}

.poll-summary-top > span {
  min-width: 0;
}

.poll-summary-top em,
.poll-summary-top strong {
  display: block;
  overflow: hidden;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.poll-summary-top em {
  color: #8b5cf6;
  font-size: 8px;
  font-weight: 900;
}

.poll-summary-top strong {
  margin-top: 3px;
  color: #334155;
  font-size: 11px;
  font-weight: 900;
}

.poll-summary-top small {
  flex: 0 0 auto;
  color: #64748b;
  font-size: 8px;
  font-weight: 800;
}

.progress-track {
  display: block;
  height: 5px;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #eeeaf5;
}

.progress-track > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #7c3aed, #a855f7);
}

.summary-empty {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  padding: 9px 11px;
  border: 1px dashed #e4dfeb;
  border-radius: 11px;
  color: #94a3b8;
  font-size: 9px;
  background: #fcfbfd;
}

.summary-empty button {
  flex: 0 0 auto;
  padding: 5px 7px;
  border: 0;
  color: #7c3aed;
  font-size: 8px;
  font-weight: 900;
  cursor: pointer;
  background: transparent;
}

.more-events {
  color: #7c3aed;
  font-weight: 900;
}

.skeleton-panel {
  display: grid;
  gap: 13px;
}

.skeleton {
  display: block;
  border-radius: 999px;
  background: linear-gradient(90deg, #eeebf2 25%, #f9f7fb 50%, #eeebf2 75%);
  background-size: 200% 100%;
  animation: dashboard-shimmer 1.2s infinite;
}

.skeleton-title {
  width: 180px;
  height: 16px;
}

.skeleton-row {
  height: 58px;
  border-radius: 13px;
}

.skeleton-hero {
  height: 170px;
  border-radius: 16px;
}

.skeleton-week {
  height: 106px;
  border-radius: 14px;
}

.skeleton-summary {
  height: 112px;
  border-radius: 13px;
}

/* Playful dashboard */
.dashboard-page {
  padding: 28px 34px 42px;
  background: radial-gradient(circle at 54% 2%, rgba(139, 92, 246, 0.09), transparent 24%), radial-gradient(circle at 98% 14%, rgba(244, 114, 182, 0.08), transparent 22%), linear-gradient(180deg, #fdfcff 0%, #f8f7fb 100%);
}

.dashboard-header,
.dashboard-content {
  max-width: 1240px;
}

.dashboard-header {
  position: relative;
  min-height: 92px;
  margin-bottom: 16px;
}

.header-copy {
  position: relative;
  z-index: 2;
}

.header-copy h1 {
  font-size: clamp(27px, 2.3vw, 34px);
}

.wave {
  display: inline-block;
  margin-left: 8px;
  font-size: 0.8em;
  transform-origin: 70% 75%;
  animation: dashboard-wave 2.5s ease-in-out infinite;
}

.header-copy > p:last-child {
  color: #7d8799;
}

.header-fun {
  position: absolute;
  right: 0;
  bottom: -17px;
  width: 330px;
  height: 100px;
  pointer-events: none;
}

.cheer-bubble {
  position: absolute;
  top: 2px;
  right: 8px;
  z-index: 3;
  padding: 8px 12px;
  border: 1px solid #ddd6fe;
  border-radius: 999px 999px 999px 7px;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 24px rgba(124, 58, 237, 0.09);
}

.cheer-bubble em {
  margin-left: 3px;
  color: #a855f7;
  font-style: normal;
}

.mascot-stage {
  position: absolute;
  right: 28px;
  bottom: 0;
  width: 210px;
  height: 74px;
}

.mascot {
  position: absolute;
  bottom: 0;
  display: block;
  border-radius: 48% 48% 21% 21%/56% 56% 18% 18%;
  box-shadow: inset -8px -8px 18px rgba(71, 29, 132, 0.08);
}

.mascot::before,
.mascot::after {
  content: "";
  position: absolute;
  top: 43%;
  width: 4px;
  height: 5px;
  border-radius: 999px;
  background: #39286c;
}

.mascot::before {
  left: 35%;
}

.mascot::after {
  right: 35%;
}

.mascot i {
  position: absolute;
  top: 57%;
  left: 50%;
  width: 8px;
  height: 4px;
  border-bottom: 1.5px solid rgba(57, 40, 108, 0.72);
  border-radius: 0 0 8px 8px;
  transform: translateX(-50%);
}

.mascot b {
  position: absolute;
  top: 52%;
  left: 15%;
  width: 7px;
  height: 3px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.42);
  box-shadow: 42px 0 0 rgba(255, 255, 255, 0.42);
}

.mascot-violet {
  left: 18px;
  width: 68px;
  height: 61px;
  background: linear-gradient(145deg, #7c3aed, #a78bfa);
  transform: rotate(-4deg);
}

.mascot-pink {
  left: 74px;
  z-index: 2;
  width: 78px;
  height: 72px;
  background: linear-gradient(145deg, #f9a8d4, #f472b6);
}

.mascot-yellow {
  left: 143px;
  width: 55px;
  height: 47px;
  background: linear-gradient(145deg, #fde68a, #fbbf24);
  transform: rotate(5deg);
}

.confetti {
  position: absolute;
  z-index: 4;
  width: 5px;
  height: 10px;
  border-radius: 999px;
  background: #f97316;
  transform: rotate(-38deg);
}

.confetti-one {
  top: 4px;
  left: 20px;
}

.confetti-two {
  top: 17px;
  left: 89px;
  background: #a78bfa;
  transform: rotate(42deg);
}

.confetti-three {
  top: 5px;
  right: 3px;
  height: 6px;
  background: #34d399;
  transform: rotate(-18deg);
}

.dashboard-content {
  grid-template-columns: minmax(340px, 0.82fr) minmax(0, 1.38fr);
  gap: 16px;
}

.attention-card,
.dashboard-content > .summary-grid {
  grid-column: 1/-1;
}

.section-card {
  border-color: rgba(226, 220, 237, 0.86);
  border-radius: 19px;
  box-shadow: 0 10px 32px rgba(65, 48, 92, 0.05);
}

.attention-card {
  padding: 22px 24px 24px;
}

.section-head h2 {
  font-size: 17px;
}

.attention-card .section-head h2::after {
  content: "🔔";
  margin-left: 6px;
  font-size: 13px;
}

.request-list {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.request-row {
  --task-accent: #f59e0b;
  --task-soft: #fff8e9;
  --task-border: #fde2af;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 13px;
  min-height: 148px;
  padding: 15px;
  border-color: #ebe7f1;
  border-radius: 15px;
  background: radial-gradient(circle at 95% 4%, var(--task-soft), transparent 37%), #fff;
}

.request-row.place {
  --task-accent: #16a36a;
  --task-soft: #eafaf3;
  --task-border: #bfead6;
}

.request-row.attendance {
  --task-accent: #f43f6e;
  --task-soft: #fff0f4;
  --task-border: #fecdd8;
}

.request-row:hover {
  border-color: var(--task-border);
  box-shadow: 0 10px 24px rgba(73, 49, 112, 0.08);
  transform: translateY(-2px);
}

.request-top {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
}

.request-icon,
.request-icon.place {
  width: 38px;
  height: 38px;
  color: var(--task-accent);
  background: var(--task-soft);
}

.request-labels {
  display: block;
  min-width: 0;
}

.request-labels em,
.request-labels span {
  display: block;
  max-width: none;
}

.request-labels em {
  padding: 0;
  color: var(--task-accent);
  background: transparent;
}

.request-labels span {
  margin-top: 3px;
  color: #8993a5;
  font-size: 8px;
}

.request-dday {
  align-self: start;
  color: var(--task-accent);
  font-size: 11px;
  font-weight: 900;
}

.request-copy {
  min-height: 37px;
}

.request-copy h3 {
  margin: 0;
  font-size: 14px;
}

.request-copy > small {
  display: block;
  margin-top: 6px;
  overflow: hidden;
  color: #8d97a8;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
}

.request-people {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #7d8798;
  font-size: 8px;
  font-weight: 800;
}

.request-people i {
  position: relative;
  width: 21px;
  height: 21px;
  border: 2px solid #fff;
  border-radius: 999px;
  background: linear-gradient(145deg, #c4b5fd, #7c3aed);
  box-shadow: 7px 0 0 -2px #f9a8d4, 14px 0 0 -2px #fcd34d;
}

.respond-button {
  min-height: 34px;
  border: 1px solid var(--task-border);
  color: var(--task-accent);
  background: var(--task-soft);
}

.respond-button:hover {
  color: #fff;
  background: var(--task-accent);
}

.quiet-state {
  border-color: #d9eee4;
  background: radial-gradient(circle at 90% 40%, rgba(52, 211, 153, 0.08), transparent 22%), #fbfefc;
}

.next-card {
  position: relative;
  overflow: hidden;
  color: #fff;
  border: 0;
  background: radial-gradient(circle at 83% 21%, rgba(255, 255, 255, 0.2), transparent 23%), radial-gradient(circle at 97% 96%, rgba(216, 180, 254, 0.55), transparent 28%), linear-gradient(145deg, #7140dc 0%, #8b5cf6 52%, #a78bfa 100%);
  box-shadow: 0 16px 36px rgba(124, 58, 237, 0.2);
}

.next-card::before,
.next-card::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 2px;
  background: #fde047;
  transform: rotate(20deg);
}

.next-card::before {
  top: 41%;
  right: 35%;
}

.next-card::after {
  top: 58%;
  right: 11%;
  width: 5px;
  height: 9px;
  background: #fb7185;
  transform: rotate(-30deg);
}

.next-card .section-head {
  position: relative;
  z-index: 2;
}

.next-card .section-head h2,
.next-card .section-head p,
.next-card .section-link {
  color: #fff;
}

.next-card .section-head p {
  opacity: 0.75;
}

.next-feature {
  position: relative;
  z-index: 2;
  grid-template-columns: minmax(0, 1fr) 92px;
  grid-template-rows: 1fr auto;
  gap: 13px 16px;
  min-height: 184px;
  padding: 8px 3px 2px;
  border: 0;
  background: transparent;
}

.feature-date {
  position: relative;
  grid-column: 2;
  grid-row: 1/3;
  width: 92px;
  height: 106px;
  align-self: center;
  color: #6d28d9;
  border: 7px solid rgba(255, 255, 255, 0.36);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 14px 24px rgba(76, 29, 149, 0.22);
  transform: rotate(7deg);
}

.feature-date::before {
  content: "";
  position: absolute;
  top: -13px;
  left: 19px;
  width: 7px;
  height: 19px;
  border-radius: 999px;
  background: #4c1d95;
  box-shadow: 37px 0 0 #4c1d95;
}

.feature-date strong {
  font-size: 34px;
}

.feature-date small {
  color: #8b5cf6;
}

.feature-copy {
  grid-column: 1;
  grid-row: 1;
}

.feature-kicker span,
.feature-kicker em,
.feature-copy h3,
.feature-meta span,
.feature-meta svg,
.attendee-info > strong {
  color: #fff;
}

.feature-kicker span,
.feature-meta span,
.attendee-info > strong {
  opacity: 0.82;
}

.feature-kicker em {
  background: rgba(76, 29, 149, 0.42);
}

.feature-copy h3 {
  font-size: 24px;
}

.feature-action {
  grid-column: 1;
  grid-row: 2;
  flex-direction: row;
  align-items: center;
  min-width: 0;
  padding: 0;
}

.detail-button {
  color: #6d28d9;
  background: #fff;
}

.detail-button:hover {
  color: #4c1d95;
  background: #faf5ff;
}

.next-empty {
  position: relative;
  z-index: 2;
  min-height: 184px;
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.next-empty h3,
.next-empty p {
  color: #fff;
}

.next-empty p {
  opacity: 0.75;
}

.week-card {
  min-width: 0;
}

.week-grid {
  gap: 0;
  overflow: hidden;
  border: 1px solid #eeeaf3;
  border-radius: 14px;
  transition: opacity 160ms ease;
}

.week-card.loading-week .week-grid {
  opacity: 0.42;
  pointer-events: none;
}

.week-day {
  min-height: 184px;
  padding: 10px 7px;
  border: 0;
  border-left: 1px solid #eeeaf3;
  border-radius: 0;
  background: #fff;
}

.week-day:first-child {
  border-left: 0;
}

.week-day.has-events {
  border-color: #eeeaf3;
  background: linear-gradient(180deg, #fff 0%, #fdfcff 100%);
}

.week-day.today {
  border-color: #eeeaf3;
  box-shadow: inset 0 -3px 0 #8b5cf6;
}

.day-head {
  justify-content: center;
  padding: 0 1px 10px;
  border-bottom: 0;
}

.day-head small {
  display: none;
}

.day-events {
  padding-top: 11px;
}

.week-event {
  border: 1px solid #ddd6fe;
  color: #6d28d9;
  background: #f7f3ff;
}

.week-day:nth-child(3n+2) .week-event {
  border-color: #bdebd5;
  color: #047857;
  background: #effcf6;
}

.week-day:nth-child(3n) .week-event {
  border-color: #fed7aa;
  color: #c2410c;
  background: #fff7ed;
}

.no-event {
  color: #e3dfeb;
}

.summary-grid {
  grid-template-columns: 1.05fr 1.05fr 0.9fr;
  align-items: stretch;
}

.summary-card {
  min-height: 242px;
}

.meeting-summary-row,
.poll-summary-row {
  border-radius: 10px;
}

.encouragement-card {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-color: #e9ddfb;
  background: radial-gradient(circle at 80% 14%, rgba(167, 139, 250, 0.17), transparent 25%), linear-gradient(145deg, #fbf8ff, #f3eaff);
}

.encouragement-copy {
  position: relative;
  z-index: 3;
}

.encouragement-copy h2 {
  margin: 0;
  color: #312e55;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: -0.03em;
}

.encouragement-copy p {
  max-width: 220px;
  margin: 7px 0 0;
  color: #7c728e;
  font-size: 9px;
  line-height: 1.6;
}

.encouragement-copy button {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-top: 12px;
  padding: 0;
  border: 0;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  cursor: pointer;
  background: transparent;
}

.encouragement-copy button svg {
  width: 12px;
  height: 12px;
}

.memory-art {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 150px;
}

.memory-illustration {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center bottom;
  filter: drop-shadow(0 12px 16px rgba(76, 29, 149, 0.12));
}

@keyframes dashboard-wave {
  0%, 55%, 100% {
    transform: rotate(0deg);
  }
  62% {
    transform: rotate(14deg);
  }
  69% {
    transform: rotate(-8deg);
  }
  76% {
    transform: rotate(11deg);
  }
  83% {
    transform: rotate(0deg);
  }
}
@keyframes dashboard-shimmer {
  to {
    background-position: -200% 0;
  }
}
@media (max-width: 1080px) {
  .header-fun {
    right: 0;
    transform: scale(0.88);
    transform-origin: right bottom;
  }
  .dashboard-content {
    grid-template-columns: 1fr;
  }
  .attention-card,
  .dashboard-content > .summary-grid {
    grid-column: auto;
  }
  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .encouragement-card {
    grid-column: 1/-1;
    min-height: 205px;
  }
  .memory-art {
    right: 0;
    left: auto;
    width: 300px;
  }
}
@media (max-width: 980px) {
  .dashboard-page {
    padding: 30px 28px 44px;
  }
  .request-row {
    min-height: 144px;
  }
  .request-deadline {
    display: none;
  }
  .next-feature {
    grid-template-columns: minmax(0, 1fr) 92px;
  }
  .feature-action {
    grid-column: 1;
    flex-direction: row;
    align-items: center;
    padding: 0;
  }
  .week-grid {
    gap: 6px;
  }
}
@media (max-width: 760px) {
  .dashboard-page {
    padding: 24px max(18px, env(safe-area-inset-right)) max(36px, env(safe-area-inset-bottom)) max(18px, env(safe-area-inset-left));
  }
  .dashboard-header {
    margin-bottom: 25px;
  }
  .header-fun {
    display: none;
  }
  .section-card {
    padding: 21px 18px;
  }
  .request-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .later-list {
    grid-template-columns: 1fr;
  }
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .encouragement-card {
    grid-column: auto;
  }
  .week-card {
    overflow: hidden;
  }
  .week-grid {
    grid-template-columns: repeat(7, 112px);
    margin: 0 -18px -8px;
    padding: 0 18px 8px;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scrollbar-width: thin;
  }
  .week-nav-button {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .respond-button,
  .detail-button,
  .inline-link,
  .section-link,
  .summary-link,
  .summary-empty button,
  .encouragement-copy button {
    min-height: 40px;
  }
}
@media (max-width: 560px) {
  .dashboard-page {
    padding: 20px max(13px, env(safe-area-inset-right)) max(30px, env(safe-area-inset-bottom)) max(13px, env(safe-area-inset-left));
  }
  .header-copy > p:last-child {
    max-width: 250px;
    font-size: 11px;
  }
  .section-head {
    align-items: flex-start;
  }
  .section-head p {
    display: none;
  }
  .week-range {
    max-width: 112px;
    text-align: center;
  }
  .request-row {
    gap: 9px;
    padding: 14px;
  }
  .request-icon {
    width: 38px;
    height: 38px;
  }
  .respond-button {
    width: auto;
    padding: 0 11px;
  }
  .quiet-state {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .inline-link {
    margin-left: 50px;
  }
  .next-feature {
    grid-template-columns: minmax(0, 1fr) 70px;
    gap: 14px;
    min-height: 174px;
    padding: 14px;
  }
  .feature-date {
    width: 70px;
    height: 88px;
    border-width: 5px;
  }
  .feature-date::before {
    left: 13px;
    box-shadow: 28px 0 0 #4c1d95;
  }
  .feature-date strong {
    font-size: 27px;
  }
  .feature-copy h3 {
    font-size: 17px;
  }
  .feature-meta span:first-child {
    display: none;
  }
  .feature-action {
    flex-wrap: wrap;
  }
  .next-empty {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .request-list {
    grid-template-columns: 1fr;
  }
  .summary-card {
    min-height: auto;
  }
  .encouragement-card {
    min-height: 235px;
  }
  .memory-art {
    right: 0;
    left: 0;
    width: auto;
  }
}
@media (max-width: 380px) {
  .dashboard-header h1 {
    font-size: 24px;
  }
  .section-card,
  .attention-card,
  .summary-card {
    padding-right: 14px;
    padding-left: 14px;
  }
  .next-feature {
    grid-template-columns: minmax(0, 1fr) 62px;
    gap: 12px;
  }
  .feature-date {
    width: 62px;
    height: 82px;
    border-width: 4px;
  }
  .feature-date::before {
    left: 11px;
    box-shadow: 25px 0 0 #4c1d95;
  }
  .feature-copy h3 {
    font-size: 16px;
  }
  .attendee-info {
    max-width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dashboard-page *,
  .dashboard-page *::before,
  .dashboard-page *::after {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public tasks: any[] = [];
    public taskTotal: number = 0;
    public upcoming: any[] = [];
    public weekDays: any[] = [];
    public meetings: any[] = [];
    public activePolls: any[] = [];
    public weekLabel: string = '';
    public weekStart: Date = this.startOfWeek(new Date());
    public weekOffset: number = 0;
    public weekLoading: boolean = false;
    public hasDashboardData: boolean = false;
    public loading: boolean = true;
    public todayLabel: string = new Intl.DateTimeFormat('ko-KR', {
        month: 'long',
        day: 'numeric',
        weekday: 'long'
    }).format(new Date());

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const response: any = await wiz.call('overview_compact', {
            week_start: this.dateKey(this.weekStart)
        });
        let overview = response.code === 200
            && response.data?.schema === 'focused-dashboard-v2'
            ? response.data
            : await this.buildCompatibilityOverview(this.weekStart);

        if (!overview) {
            const legacy: any = await wiz.call('overview_v2');
            overview = legacy.code === 200 ? legacy.data : null;
        }

        if (overview) {
            this.tasks = (overview.tasks || []).slice(0, 3);
            this.taskTotal = Number(
                overview.task_total ?? this.tasks.length
            );
            this.upcoming = (overview.upcoming || [])
                .slice(0, 3)
                .map((item: any) => ({
                    ...item,
                    attendee_profiles: (
                        Array.isArray(item.attendee_profiles)
                        && item.attendee_profiles.length > 0
                    )
                        ? item.attendee_profiles
                        : (item.attendee_names || []).map((name: string) => ({
                            name,
                            profile_image: ''
                        }))
                }));
            this.weekDays = overview.week_days || this.emptyWeekDays(this.weekStart);
            this.meetings = (overview.meetings || []).slice(0, 5);
            this.activePolls = (overview.active_polls || []).slice(0, 4);
            this.weekLabel = overview.week_label || this.currentWeekLabel();
            this.hasDashboardData = !!overview.has_data;
        } else {
            this.tasks = [];
            this.taskTotal = 0;
            this.upcoming = [];
            this.weekDays = this.emptyWeekDays(this.weekStart);
            this.meetings = [];
            this.activePolls = [];
            this.weekLabel = this.currentWeekLabel();
            this.hasDashboardData = false;
        }

        this.loading = false;
        await this.service.render();
    }

    private async buildCompatibilityOverview(
        selectedWeekStart: Date = this.weekStart
    ) {
        try {
            const listResult = await this.membersApi('list');
            const meetings = listResult?.code === 200
                && Array.isArray(listResult.data)
                ? listResult.data
                : null;
            if (!meetings) return null;

            const detailResults = await Promise.all(
                meetings.map((meeting: any) => this.membersApi(
                    'detail',
                    { id: meeting.id }
                ))
            );
            const details = detailResults
                .filter((result: any) => result?.code === 200 && result.data)
                .map((result: any) => result.data);
            return this.composeOverview(
                meetings,
                details,
                selectedWeekStart
            );
        } catch (error) {
            return null;
        }
    }

    private async membersApi(action: string, params: any = {}) {
        const body = new URLSearchParams();
        Object.keys(params).forEach((key) => {
            body.set(key, String(params[key] ?? ''));
        });
        const response = await fetch(`/wiz/api/page.members/${action}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: body.toString()
        });
        return await response.json();
    }

    private composeOverview(
        meetings: any[],
        details: any[],
        selectedWeekStart: Date = this.weekStart
    ) {
        const now = new Date();
        const weekStart = this.startOfWeek(selectedWeekStart);
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 7);
        const tasks: any[] = [];
        const upcoming: any[] = [];
        const weeklySchedules: any[] = [];
        const activePolls: any[] = [];

        details.forEach((detail: any) => {
            const meeting = detail.meeting || {};
            const meetingName = meeting.name || '';
            const meetingId = meeting.id || '';
            const members = detail.members || [];

            (detail.polls || []).forEach((poll: any) => {
                const closesAt = this.parseDate(poll.closes_at);
                const currentParticipants = Number(poll.response_count || 0);
                const totalParticipants = Number(
                    poll.member_count || members.length
                );
                if (poll.is_open) {
                    activePolls.push({
                        id: poll.id,
                        meeting_id: meetingId,
                        meeting_name: meetingName,
                        title: poll.title || '',
                        kind: poll.kind || 'schedule',
                        kind_label: poll.kind === 'place' ? '장소 투표' : '일정 투표',
                        current_participants: currentParticipants,
                        total_participants: totalParticipants,
                        progress: totalParticipants
                            ? Math.min(
                                100,
                                Math.round(
                                    currentParticipants / totalParticipants * 100
                                )
                            )
                            : 0,
                        _sortAt: closesAt?.getTime() ?? Number.MAX_SAFE_INTEGER
                    });
                }

                const responded = (poll.options || []).some(
                    (option: any) => !!option.my_selected
                );
                if (!poll.is_open || responded) return;

                const deadline = this.deadlineMeta(closesAt, now);
                tasks.push({
                    id: poll.id,
                    meeting_id: meetingId,
                    meeting_name: meetingName,
                    title: poll.title || '',
                    kind: poll.kind || 'schedule',
                    kind_label: poll.kind === 'place' ? '장소 투표' : '일정 투표',
                    deadline: deadline.label,
                    deadline_at: closesAt?.toISOString() || '',
                    deadline_detail: this.formatDateTime(closesAt),
                    urgency: deadline.tone,
                    current_participants: currentParticipants,
                    total_participants: totalParticipants,
                    _sortAt: closesAt?.getTime() ?? Number.MAX_SAFE_INTEGER
                });
            });

            (detail.schedules || []).forEach((schedule: any) => {
                const startsAt = this.parseDate(schedule.schedule_at);
                const endsAt = this.parseDate(
                    schedule.schedule_end_at || schedule.schedule_at
                );
                if (!startsAt) return;
                const participants = schedule.participants || members;
                const attendeeProfiles = participants
                    .filter((participant: any) => !!participant.user_name)
                    .map((participant: any) => ({
                        name: participant.user_name,
                        profile_image: participant.profile_image || ''
                    }))
                    .slice(0, 3);

                const item = {
                    id: schedule.id,
                    meeting_id: meetingId,
                    meeting_name: meetingName,
                    title: schedule.title || '',
                    place: schedule.place || '장소 미정',
                    all_day: !!schedule.all_day,
                    starts_at: startsAt.toISOString(),
                    ends_at: (endsAt || startsAt).toISOString(),
                    date_label: this.formatDateTime(startsAt),
                    date_only_label: this.formatDateOnly(startsAt),
                    time_label: schedule.all_day
                        ? '종일'
                        : this.formatTime(startsAt),
                    month_label: `${startsAt.getMonth() + 1}월`,
                    day_label: String(startsAt.getDate()),
                    weekday_label: this.weekday(startsAt),
                    dday: this.dday(startsAt, now),
                    attendee_count: participants.length,
                    attendee_names: attendeeProfiles.map(
                        (attendee: any) => attendee.name
                    ),
                    attendee_profiles: attendeeProfiles,
                    _start: startsAt,
                    _end: endsAt || startsAt,
                    _sortAt: startsAt.getTime()
                };

                if (item._end.getTime() >= now.getTime()) {
                    upcoming.push({ ...item });
                }
                if (
                    item._end.getTime() >= weekStart.getTime()
                    && item._start.getTime() < weekEnd.getTime()
                ) {
                    weeklySchedules.push(item);
                }
            });
        });

        tasks.sort((left, right) => left._sortAt - right._sortAt);
        upcoming.sort((left, right) => left._sortAt - right._sortAt);
        weeklySchedules.sort((left, right) => left._sortAt - right._sortAt);
        activePolls.sort((left, right) => left._sortAt - right._sortAt);

        const weekDays = Array.from({ length: 7 }, (_, offset) => {
            const day = new Date(weekStart);
            day.setDate(weekStart.getDate() + offset);
            const events = weeklySchedules
                .filter((schedule: any) => (
                    this.dateOnly(schedule._start).getTime() <= day.getTime()
                    && this.dateOnly(schedule._end).getTime() >= day.getTime()
                ))
                .map((schedule: any) => ({
                    id: schedule.id,
                    meeting_id: schedule.meeting_id,
                    meeting_name: schedule.meeting_name,
                    title: schedule.title,
                    place: schedule.place,
                    all_day: schedule.all_day,
                    starts_at: schedule.starts_at,
                    ends_at: schedule.ends_at,
                    time_label: (
                        !schedule.all_day
                        && this.dateOnly(schedule._start).getTime() < day.getTime()
                    )
                        ? '계속'
                        : schedule.time_label
                }));
            return {
                date: this.dateKey(day),
                weekday_label: this.weekday(day),
                month_label: `${day.getMonth() + 1}월`,
                day_label: String(day.getDate()),
                is_today: this.dateKey(day) === this.dateKey(now),
                events
            };
        });

        [tasks, upcoming].forEach((items: any[]) => {
            items.forEach((item: any) => {
                delete item._start;
                delete item._end;
                delete item._sortAt;
            });
        });
        activePolls.forEach((item: any) => delete item._sortAt);

        return {
            schema: 'focused-dashboard-v2',
            tasks: tasks.slice(0, 3),
            task_total: tasks.length,
            upcoming: upcoming.slice(0, 3),
            week_days: weekDays,
            meetings: meetings.slice(0, 5).map((meeting: any) => ({
                id: meeting.id,
                name: meeting.name || '',
                member_count: Number(meeting.member_count || 0),
                schedule_count: Number(meeting.schedule_count || 0),
                my_role: meeting.my_role || ''
            })),
            active_polls: activePolls.slice(0, 4),
            week_label: this.weekRangeLabel(weekStart),
            has_data: meetings.length > 0
        };
    }

    private emptyWeekDays(selectedWeekStart: Date = this.weekStart) {
        const weekStart = this.startOfWeek(selectedWeekStart);
        return Array.from({ length: 7 }, (_, offset) => {
            const day = new Date(weekStart);
            day.setDate(weekStart.getDate() + offset);
            return {
                date: this.dateKey(day),
                weekday_label: this.weekday(day),
                month_label: `${day.getMonth() + 1}월`,
                day_label: String(day.getDate()),
                is_today: this.dateKey(day) === this.dateKey(new Date()),
                events: []
            };
        });
    }

    private startOfWeek(value: Date) {
        const date = this.dateOnly(value);
        const mondayOffset = (date.getDay() + 6) % 7;
        date.setDate(date.getDate() - mondayOffset);
        return date;
    }

    private dateOnly(value: Date) {
        return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    private dateKey(value: Date) {
        return [
            value.getFullYear(),
            String(value.getMonth() + 1).padStart(2, '0'),
            String(value.getDate()).padStart(2, '0')
        ].join('-');
    }

    private currentWeekLabel() {
        return this.weekRangeLabel(this.weekStart);
    }

    private weekRangeLabel(weekStart: Date) {
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);
        return `${weekStart.getMonth() + 1}월 ${weekStart.getDate()}일 - ${weekEnd.getMonth() + 1}월 ${weekEnd.getDate()}일`;
    }

    private parseDate(value: any): Date | null {
        if (!value) return null;
        const date = value instanceof Date
            ? value
            : new Date(String(value).replace(' ', 'T'));
        return isNaN(date.getTime()) ? null : date;
    }

    private formatDateOnly(value: Date) {
        return `${value.getFullYear()}년 ${value.getMonth() + 1}월 ${value.getDate()}일 (${this.weekday(value)})`;
    }

    private formatDateTime(value: Date | null) {
        if (!value) return '마감일 없음';
        return `${this.formatDateOnly(value)} ${this.formatTime(value)}`;
    }

    private formatTime(value: Date) {
        return [
            String(value.getHours()).padStart(2, '0'),
            String(value.getMinutes()).padStart(2, '0')
        ].join(':');
    }

    private weekday(value: Date) {
        return ['일', '월', '화', '수', '목', '금', '토'][value.getDay()];
    }

    private dayDistance(start: Date, end: Date) {
        const startUtc = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
        const endUtc = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
        return Math.round((endUtc - startUtc) / 86400000);
    }

    private dday(value: Date, now: Date) {
        const days = this.dayDistance(now, value);
        return days <= 0 ? 'D-Day' : `D-${days}`;
    }

    private deadlineMeta(value: Date | null, now: Date) {
        if (!value) return { label: '마감일 없음', tone: 'normal' };
        const days = this.dayDistance(now, value);
        const remaining = value.getTime() - now.getTime();
        const label = days <= 0
            ? '오늘 마감'
            : days === 1
                ? '내일 마감'
                : `D-${days}`;
        const tone = remaining <= 24 * 60 * 60 * 1000
            ? 'danger'
            : remaining <= 72 * 60 * 60 * 1000
                ? 'warning'
                : 'normal';
        return { label, tone };
    }

    public async changeWeek(direction: number) {
        if (this.weekLoading || ![-1, 1].includes(direction)) return;

        const targetWeek = new Date(this.weekStart);
        targetWeek.setDate(targetWeek.getDate() + direction * 7);
        this.weekStart = this.startOfWeek(targetWeek);
        this.weekOffset += direction;
        this.weekLabel = this.weekRangeLabel(this.weekStart);
        this.weekLoading = true;
        await this.service.render();

        try {
            const response: any = await wiz.call('overview_week', {
                week_start: this.dateKey(this.weekStart)
            });
            const overview = response.code === 200
                && response.data?.schema === 'focused-dashboard-v2'
                ? response.data
                : await this.buildCompatibilityOverview(this.weekStart);

            this.weekDays = overview?.week_days
                || this.emptyWeekDays(this.weekStart);
            this.weekLabel = overview?.week_label
                || this.weekRangeLabel(this.weekStart);
        } catch (error) {
            this.weekDays = this.emptyWeekDays(this.weekStart);
        } finally {
            this.weekLoading = false;
            await this.service.render();
        }
    }

    public openTask(task: any) {
        if (!task?.meeting_id) return;
        this.router.navigate(
            ['/meetings', task.meeting_id],
            { queryParams: { poll: task.id } }
        );
    }

    public openSchedule(schedule: any) {
        if (!schedule?.meeting_id) return;
        this.router.navigate(
            ['/meetings', schedule.meeting_id],
            { queryParams: { schedule: schedule.id } }
        );
    }

    public openMeeting(meeting: any) {
        if (!meeting?.id) return;
        this.router.navigate(['/meetings', meeting.id]);
    }

    public openMeetingAction(action: 'create' | 'join') {
        this.router.navigate(
            ['/meetings'],
            { queryParams: { action } }
        );
    }

    public initial(name: string) {
        return (name || '?').trim().charAt(0);
    }

    public trackById(index: number, item: any) {
        return item.id || index;
    }

    public trackByDay(index: number, day: any) {
        return day.date || index;
    }
}

export default PageDashboardComponent;